import { Grid } from "@mui/material";
import { styled } from '@mui/material/styles';

export const GridLayout = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.rootContainer.background,
  color: theme.palette.rootContainer.color,
  height: "100vh",
  width: window.innerWidth
}));